<script lang="ts">
  import type { CategoryPropConfig } from '../../modules/projects/project.interface';
  import { CategoryPropType } from '../../modules/projects/project.interface';
  import ItemPropTextInput from './ItemPropTextInput.svelte';
  import ItemPropNumberInput from './ItemPropNumberInput.svelte';
  import ItemPropColorsInput from './ItemPropColorsInput.svelte';
  import ItemPropImageUpload from './ItemPropImageUpload.svelte';
  import ItemPropBoolean from './ItemPropBoolean.svelte';

  export let value: any;
  export let categoryPropConfig: CategoryPropConfig;
  export let message: string;
  export let path = '';

  const Component = getComponentByType(categoryPropConfig);

  function getComponentByType(categoryPropConfig: CategoryPropConfig) {
    const components = {
      [CategoryPropType.TEXT]: ItemPropTextInput,
      [CategoryPropType.NUMBER]: ItemPropNumberInput,
      [CategoryPropType.URL]: ItemPropTextInput,
      [CategoryPropType.IMAGE]: ItemPropImageUpload,
      [CategoryPropType.COLORS]: ItemPropColorsInput,
      [CategoryPropType.BOOLEAN]: ItemPropBoolean,
    };

    return components[categoryPropConfig.type];
  }
</script>

<div class="prop-input">
  <svelte:component
    this={Component}
    bind:value
    {categoryPropConfig}
    {path}
    on:fileAdded
  />
  {#if message && message !== 'valid'}
    <span class="prop-message red-text">{message}</span>
  {/if}
</div>

<style lang="scss">
  .prop-input {
    position: relative;
    padding-bottom: 24px;
  }

  .prop-message {
    position: absolute;
    bottom: 10px;
    font-size: 12px;
  }
</style>
